import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  output,
  signal,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-z-ticket',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-z-ticket.component.html',
})
export class ModalZTicketComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly pdf = input.required<Blob>();

  closeClick = output<void>();
  downloadClick = output<void>();

  protected readonly pdfUrl = signal<SafeResourceUrl | null>(null);

  constructor() {
    effect((onCleanup) => {
      const url = URL.createObjectURL(this.pdf());
      this.pdfUrl.set(this.sanitizer.bypassSecurityTrustResourceUrl(url));
      onCleanup(() => URL.revokeObjectURL(url));
    });
  }
}
